import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import { AnswerID } from '@aytm/app/swidget/base/questions/types'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../../types.ts'
import { useFamilyAxes } from '../../hooks/useFamilyAxes.ts'
import { LEGACY_AXIS } from '../../utils/familyAxes.ts'
import style from './VariantSelect.module.scss'

interface IVariantSelectProps {
  schema: IEcommerceQuestionSchema
  answer: IEcommerceAnswerSchema
  onSelect: (id: AnswerID) => void
}

const VariantSelect = ({ schema, answer, onSelect }: IVariantSelectProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()
  const {
    childrenProducts,
    axes,
    currentSelections,
    findSKUForValue,
    isCompatibleWithUpperAxes,
    isCombinationAvailable
  } = useFamilyAxes({
    answer,
    schema
  })

  if (childrenProducts.length <= 1 || 0 === axes.length) return null

  const onChange = (axisName: string, value: string) => {
    const targetSKU = findSKUForValue(axisName, value)
    if (targetSKU && targetSKU.id !== answer.id) onSelect(targetSKU.id)
  }

  if (viewport.mobile) {
    return (
      <div className={style.variants}>
        {axes.map(axis => {
          const selectedValue = currentSelections[axis.name] || ''
          return (
            <div key={axis.name}>
              {axis.name !== LEGACY_AXIS && (
                <div className={style.chipsLabel}>
                  {t<(axis: string) => string>('questions', 'ec', 'kroger', 'selectAxis')(axis.name)}
                </div>
              )}
              <div className={style.chips}>
                {axis.values.map(value => (
                  <button
                    type="button"
                    key={value}
                    className={`${style.chip} ${value === selectedValue ? style.chipSelected : ''} ${
                      isCombinationAvailable(axis.name, value) ? '' : style.chipUnavailable
                    }`}
                    onClick={() => onChange(axis.name, value)}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={style.variants}>
      {axes.map((axis, axisIndex) => {
        const selectedValue = currentSelections[axis.name] || ''
        return (
          <div key={axis.name}>
            {axis.name !== LEGACY_AXIS && (
              <div className={style.label}>
                <span className={style.labelName}>{axis.name}:</span> <span>{selectedValue}</span>
              </div>
            )}
            <select
              className={style.select}
              value={selectedValue}
              onChange={event => onChange(axis.name, event.target.value)}
            >
              {axis.values
                .filter(value => isCompatibleWithUpperAxes(axisIndex, value))
                .map(value => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
            </select>
          </div>
        )
      })}
    </div>
  )
}

export default VariantSelect
